import React from "react";
const InputHelpText = (props) => {
  if (!props.helpText) return null;
  return <small className="form-text text-muted">{props.helpText}</small>;
};

export default InputHelpText;
